<template>
  <div class="u-wrap">
    <div class="u-content">
    <img class="top-img" src="@images/xf-top.png" />
    <div class="sjzt">
      <div class="sjzt-item">
        <span class="label">信访件编号</span>
        <span class="val">{{obj.xfjbh||'--'}}</span>
      </div>
      <div class="sjzt-item">
        <span class="label">当前状态</span>
        <span class="val">{{obj.lcjd_dictText||'--'}}</span>
      </div>
      <div class="sjzt-item">
        <span class="label">处理时间</span>
        <span class="val">{{obj.updateTime||'--'}}</span>
      </div>
    </div>

    <div class="lc">
      <div class="title">事件处理流程</div>
      <div class="time-line">
        <div class="time-line-item" v-for="(item, index) in lcList" :key="index">
          <div class="time-line-left">
            <div class="zt"><span></span></div>
          </div>
          <div class="time-line-right">
            <div class="time-line-right-top">{{item.lczt_dictText}}</div>
            <div class="time-line-right-bottom">
            <div v-if="item.lczt==1" class="time">
              受理时间：{{item.createTime}}</div>
            <div v-else class="time">
              处理时间：{{item.createTime}}</div>
             <div v-if="item.lczt==1" class="content">
             受理人：{{item.createBy_dictText}} </div>
              <div v-else class="content">
             处理人：{{item.createBy_dictText}} </div>

              <div v-if="item.lczt=='8' " class="content">
             办理类型：{{item.bllx_dictText}} </div>

               <div v-if="item.auditOpinion && item.lczt != '8' && item.lczt != '16' && item.lczt !='7' && item.lczt !=='6' && item.lczt !=='10' && item.lczt !=='11' && item.lczt !=='17' && item.lczt !=='18'  " class="content">
             备注：{{item.auditOpinion}} </div>

               <div v-if="item.auditOpinion && (item.lczt == '8' || item.lczt == '16' )" class="content">
             处理意见：{{item.auditOpinion}} </div>

               <div v-if="item.blbz && (item.lczt == '8' || item.lczt == '16' )" class="content">
             备注：{{item.blbz}} </div>

               <div v-if="item.lczt =='17' && item.fcsllx" class="content">
             复查受理类型：{{item.fcsllx_dictText}}</div>

                <div v-if="item.auditor_dictText && (item.lczt=='7' || item.lczt=='6' )  " class="content">责任部门：{{item.auditor_dictText}}</div>

                <div v-if="item.lczt=='7' || item.lczt=='6'" class="content">配合部门：{{item.phbm||'无'}}</div>
                <div v-if="item.auditOpinion &&  item.lczt == '11' " class="content">复核意见：{{item.auditOpinion}}</div>
                <div v-if="item.auditOpinion && (item.lczt =='7' || item.lczt =='6') " class="content">提醒意见：{{item.auditOpinion}}</div>
                <div v-if="item.blbz && item.lczt == '18' " class="content">处理意见：{{item.blbz}}</div>
                <div v-if="item.auditOpinion && (item.lczt == '17' || item.lczt == '18') " class="content">补充信息：{{item.auditOpinion}}</div>
              </div>
          </div>
        </div>
      </div>
    </div>
   </div>
    <div v-if="obj.lcjd =='bj'||obj.lcjd=='10'||obj.lcjd=='11'" class="b-btn">
      <button class="b-button"  @click="clickPj">{{name}}</button>
    </div>
  </div>
</template>

<script>
import { postAction,getAction } from '@/api/manage'
export default {
  data() {
    return {
      obj:{},
      show:false,
      lcList:[],
      name:'',
      pjObj:{},
    }
  },
  created() {
    // this.model.mydpjjb = this.list[0].code;
    let params = this.$route.query;
    this.id = params.id||'';
    this.initData();
  
  },
  mounted() {},
  methods: {
    initData(){
     let url = '/zhshj/xfgzxfdjpj/query/by/xfdjid';
     let params = {xfdjId:this.id}
       getAction(url, params).then((res) => {
         if(res.success){
         let obj =res.result;
          if(obj&&obj.length>0){
            this.obj = obj[0];
          }
           this.getSfkpj();
           this.getList();  
         }else{
          this.$toast(res.message)
         }
       
      })
   
    },
    getSfkpj(){
      let url = '/zhshj/xfgzxfdjpj/sfkpj'
      let params = {xfdjId:this.id}
       getAction(url, params).then((res) => {
         if(res.success){
         let obj =res.result;
         this.pjObj = obj;
         if(obj){
          this.name = '查看评价' 
         }else{
          this.name = '评价' 
         }
          // this.show = obj==0?true:false;
         }
       
      })
    },
    getList(){
        let url = '/zhshj/xfgzxfdjlccl/query/by/xfdj/id/workflow'
      let params = {id:this.id}
       getAction(url, params).then((res) => {
         if(res.success){
          this.lcList =res.result;
         }
       
      })
    },
    clickPj() {
      if(this.pjObj){
        let params = {pjlb:this.pjObj.pjlb,pjnr:this.pjObj.pjnr}
        this.$router.push({
            path: '/xf/pj-view',
            query:params,
          })

      }else{
        let params = {xfdjId:this.id,phone:this.obj.phone,xfjbh:this.obj.xfjbh}
       this.$router.push({
            path: '/xf/pj',
            query:params,
          })
      }
     
    },
    getUrlParams() {
			// 截取url中的code方法
			var url = location.search;
      console.log(url);
			var theRequest = new Object();
			if (url.indexOf("?") != -1) {
				var str = url.substr(1);
				var strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
				}
			}
			return theRequest;
		},
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  box-sizing: border-box;
  background-color: #F8F8F8;
  display: flex;
  flex-direction: column;
  // padding-bottom: 60px;
  // background-image: linear-gradient(180deg, #d2e3ff 0%, #ffffff 30%);
}
 .top-img {
    width: 100%;
    height: auto;
    vertical-align: middle;
  }

.sjzt {
  background: #fff;
  padding: 0 10px;
  margin-bottom: 10px;

  .sjzt-item {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    padding: 0 5px;
    font-size: 16px;
    &:not(:last-child) {
      border-bottom: 0.5px solid #E9E9E9;
    }
    .label {
      color: #333333;
    }
    .val {
      color: #666666;
    }
  }
}

.lc {
  background: #FFFFFF;
  padding: 14px;
  .title {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    margin-bottom: 14px;
  }

  .time-line {

    .time-line-item {
      display: flex;
      .time-line-left {
        width: 30px;
        position: relative;
        margin-top: 5px;
        &::before {
          content: '';
          position: absolute;
          width: 0px;
          height: calc(100%);
          border-left: 1px dashed #2793E2;
          left: 7px;
          top: 7px;
          z-index: 0;
        }
         &::after {
          content: '';
          position: absolute;
          width: 16px;
          height: 0;
          border-top: 1px dashed #2793E2;
          left: 14px;
          top: 7px;
          z-index: 0;
        }
        .zt{
          width: 14px;
          height: 14px;
          background:#2593e11a;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

           span {
              width: 10px;
              height: 10px;
              background-color: #2593E1;
              display: inline-block;
              text-align: center;
              color: #fff;
              border-radius: 50%;
        }
        }
       
      }

      .time-line-right {
        flex: 1;
       

        .time-line-right-top{
          background: #2593E1;
          border-radius: 3px;
          padding: 5px 13px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 12px;
          color: #FFFFFF;
          display: inline-block;
          margin-bottom: 12px;
        }

        .time-line-right-bottom{
        padding: 10px 12px;
        background: #F6FAFF;
        border: 0.5px solid #D3E0F3;
        border-radius: 3px;
        margin-bottom: 15px;
 
        .time {
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          margin-bottom: 5px;
        }

        .content{
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          letter-spacing: 0;
          margin-bottom: 4px;
        }
        }

      


      }

      &:last-child{
        .time-line-left{
          &::before{
            height: 0;
          }
        }
      }
    }
  }
}
   
.b-btn{
  width: 100%;
  height: 75px;
  background: #FFFFFF;
  flex-shrink: 0;
  // box-shadow: 0 -1px 4px #E6E6E680;
  // box-shadow: 0 -2px 7px 0 #e6e6e680;
  display: flex;
  align-items: center;
  padding: 0 22px;
  box-sizing: border-box;
  border-top: 1px solid #e3e3e3;

  .b-button{
    width: 100%;
    height: 40px;
    background: #2593E1;
    border-radius: 40px;
    border: none;
    color: #FFF;
  }
}

.u-content{
  flex: 1;
  overflow-y: scroll;
}

</style>
